import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

import CustomTextField from "../../../../components/CustomTextField";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import useTenant from "../../../../hooks/useTenant";
import usePlanGroup from "../../../../hooks/usePlanGroup";
import useAuth from "../../../../hooks/useAuth";
import usePaymentGateway from "../../../../hooks/usePaymentGateway";
import CustomSwitch from "../../../../components/CustomSwitch";
import { useTranslation } from "react-i18next";

const currentMsoPayload = {
  filters: [
    {
      fieldName: "businessType",
      fieldValue: "MULTI_SERVICE_OPERATOR",
      op: "eq",
      dataType: "businessType",
      isJoin: false,
    },
  ],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const currentDSTPayload = {
  filters: [
    {
      fieldName: "businessType",
      fieldValue: "DISTRIBUTOR",
      op: "eq",
      dataType: "businessType",
      isJoin: false,
    },
  ],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const TenantDetail = (props) => {
  const [businessTypes, setBusinessTypes] = useState([
    {
      value: "LOCAL_CABLE_OPERATOR",
      label: "LCO - Local Cable Operator",
    },
    {
      value: "DISTRIBUTOR",
      label: "DST - Distributor",
    },
    {
      value: "MULTI_SERVICE_OPERATOR",
      label: "MSO - Multi Service Operator",
    },
    {
      value: "BULK_BANDWIDTH",
      label: "BBW - Bulk Bandwidth",
    },
    {
      value: "HOTEL",
      label: "Hotel",
    },
    {
      value: "DOT",
      label: "DOT",
    },
  ]);

  const { t } = useTranslation();

  const {
    autoSearchPaymentGateway,
    paymentGatewayAutoSearchResults,
    isLoadingAutoSearch: paymentGateLoading,
  } = usePaymentGateway();

  const { autoSearchPlanGroup, planGroupAutoSearchResults, isLoadingAutoSearch } = usePlanGroup();
  const {
    register,
    formState: { errors },
    watch,
    control,
    setValue,
  } = useFormContext();

  const { user } = useAuth();

  const businessType = watch("businessType");
  const sharingType = watch("sharingType");
  const isAgrEnabled = watch("isAgrEnabled");

  const { fields, isEditable } = props;

  const [msoPayload, setMsoPayload] = useState(currentMsoPayload);
  const [msoOptions, setMsoOptions] = useState([]);

  const [distPayload, setDistPayload] = useState(currentDSTPayload);
  const [distOptions, setDistOptions] = useState([]);
  const [planGroupOptions, setPlanGroupOptions] = useState([]);
  const [planGroupPayload, setPlanGroupPayload] = useState({
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  });
  const [paymentGatewayPayload, setPaymentGatewayPayload] = useState({
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  });
  const [paymentGatewayOptions, setPaymentGatewayOptions] = useState([]);

  const selectedPaymentGateway = watch("paymentGateway");

  const [isMsoVisible, setIsMsoVisible] = useState(true);

  console.log(selectedPaymentGateway, "selectedPaymentGateway");

  useEffect(() => {
    if (user && user.businessType == "MULTI_SERVICE_OPERATOR") {
      setBusinessTypes([
        {
          value: "LOCAL_CABLE_OPERATOR",
          label: "LCO - Local Cable Operator",
        },
        {
          value: "DISTRIBUTOR",
          label: "DST - Distributor",
        },
        {
          value: "BULK_BANDWIDTH",
          label: "BBW - Bulk Bandwidth",
        },
        {
          value: "HOTEL",
          label: "Hotel",
        },
      ]);
      setValue("mso", {
        label: user.name,
        value: user.tenantId,
      });
      setIsMsoVisible(false);
    }
  }, [user]);

  const { autoSearchTenant } = useTenant();

  const [msoAutoSearchResults, setMsoAutoSearchResults] = useState({
    data: [],
  });
  const [distAutoSearchResults, setDistAutoSearchResults] = useState({
    data: [],
  });

  const fetchMsos = async () => {
    const msoResults = await autoSearchTenant(msoPayload);
    setMsoAutoSearchResults(msoResults);
  };

  const fetchDisitributors = async () => {
    const dstResults = await autoSearchTenant(distPayload);
    console.log(dstResults, "dstResults");
    setDistAutoSearchResults(dstResults);
  };
  const fetchPlanGroups = async () => {
    await autoSearchPlanGroup(planGroupPayload);
  };

  const fetchPaymentGateway = async () => {
    await autoSearchPaymentGateway(paymentGatewayPayload);
  };

  useEffect(() => {
    fetchMsos();
  }, [msoPayload]);

  useEffect(() => {
    fetchDisitributors();
    setValue("isSharingAllowed", businessType == "LOCAL_CABLE_OPERATOR");
  }, [businessType, distPayload]);

  useEffect(() => {
    fetchPlanGroups();
  }, [planGroupPayload]);

  useEffect(() => {
    fetchPaymentGateway();
  }, [paymentGatewayPayload]);

  useEffect(() => {
    console.log("msoOptions", msoAutoSearchResults);
    if (msoAutoSearchResults && msoAutoSearchResults.data.length !== 0) {
      const results = [...msoOptions, ...msoAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setMsoOptions(filteredResults);
    }
  }, [msoAutoSearchResults]);

  useEffect(() => {
    if (distAutoSearchResults && distAutoSearchResults.data.length !== 0) {
      const results = [...distOptions, ...distAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setDistOptions(filteredResults);
    }
  }, [distAutoSearchResults]);

  useEffect(() => {
    if (planGroupAutoSearchResults && planGroupAutoSearchResults.data.length !== 0) {
      const results = [...planGroupOptions, ...planGroupAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setPlanGroupOptions(filteredResults);
    }
  }, [planGroupAutoSearchResults]);

  useEffect(() => {
    console.log("paymentGatewayAutoSearchResults", paymentGatewayAutoSearchResults);
    if (paymentGatewayAutoSearchResults && paymentGatewayAutoSearchResults.data.length !== 0) {
      const results = [...paymentGatewayOptions, ...paymentGatewayAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setPaymentGatewayOptions(filteredResults);
    }
  }, [paymentGatewayAutoSearchResults]);

  useEffect(() => {
    if (!isAgrEnabled) {
      setValue("agrSharing", 0);
    }
  }, [isAgrEnabled]);

  return (
    <Grid container spacing={12} className="row" pt={8}>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          id="businessType"
          name="businessType"
          label={t("business_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        >
          {businessTypes &&
            businessTypes.map((businessTypeData) => {
              return <MenuItem value={businessTypeData.value}>{businessTypeData.label}</MenuItem>;
            })}
        </ReactHookFormSelect>
      </Grid>
      {businessType != "MULTI_SERVICE_OPERATOR" && isMsoVisible && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <SearchableAutoComplete
            control={control}
            data={msoOptions}
            label={t("mso")}
            payload={msoPayload}
            setPayload={setMsoPayload}
            loading={false}
            name="mso"
            multiple={false}
            defaultValue={""}
            hasNextPage={false}
            fields={fields}
            errors={errors}
          />
        </Grid>
      )}
      {businessType == "LOCAL_CABLE_OPERATOR" && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <SearchableAutoComplete
            control={control}
            data={distOptions}
            label={t("distributor")}
            payload={distPayload}
            setPayload={setDistPayload}
            loading={false}
            name="distributor"
            multiple={false}
            defaultValue={""}
            hasNextPage={false}
            fields={fields}
            errors={errors}
          />
        </Grid>
      )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("franchise_name")}
          name="tenantName"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("official_mobile_no")}
          name="officialMobileNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("official_email_id")}
          name="officialEmailId"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("gst_no")}
          name="gstNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        />
      </Grid>
      <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="serviceType"
          label={t("service_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        >
          <MenuItem value={"INTERNET"}>Internet</MenuItem>
          <MenuItem value={"COMBO"}>Combo</MenuItem>
          <MenuItem value={"INTERNET_OTT"}>Internet + OTT</MenuItem>
        </ReactHookFormSelect>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          id="sharingType"
          name="sharingType"
          label={t("sharing_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        >
          <MenuItem value={"POLICY_WISE"}>Policy Wise</MenuItem>
          <MenuItem value={"FIXED"}>Fixed</MenuItem>
        </ReactHookFormSelect>
      </Grid>
      {businessType != "MULTI_SERVICE_OPERATOR" && isEditable && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <SearchableAutoComplete
            control={control}
            data={planGroupOptions}
            label={t("plan_group")}
            payload={planGroupPayload}
            setPayload={setPlanGroupPayload}
            loading={false}
            name="planGroup"
            multiple={false}
            defaultValue={""}
            hasNextPage={false}
            fields={fields}
          />
        </Grid>
      )}
      {businessType == "MULTI_SERVICE_OPERATOR" && isMsoVisible && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <SearchableAutoComplete
            control={control}
            data={paymentGatewayOptions}
            label={t("payment_gateway")}
            payload={paymentGatewayPayload}
            setPayload={setPaymentGatewayPayload}
            loading={false}
            name="paymentGateway"
            multiple={false}
            defaultValue={""}
            hasNextPage={false}
            fields={fields}
            errors={errors}
          />
        </Grid>
      )}
      {businessType == "MULTI_SERVICE_OPERATOR" &&
        isMsoVisible &&
        selectedPaymentGateway &&
        selectedPaymentGateway.label == "RazorPay" && (
          <>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("razorpay_key_id")}
                name="keyId"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={fields}
              />
            </Grid>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("razorpay_key_value")}
                name="keyValue"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={fields}
              />
            </Grid>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <CustomTextField
                label="Razorpay Webhook Secret"
                name="webHookSecret"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={fields}
              />
            </Grid>
          </>
        )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomSwitch
          label={t("is_agr_enabled")}
          name="isAgrEnabled"
          errors={errors}
          fields={fields}
        />
      </Grid>
      {businessType == "MULTI_SERVICE_OPERATOR" && isAgrEnabled && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("agr_sharing")}
            name="agrSharing"
            type="text"
            my={2}
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={fields}
          />
        </Grid>
      )}{" "}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          id="status"
          name="status"
          label={t("Status")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={fields}
        >
          <MenuItem value={"ACTIVE"}>Active</MenuItem>
          <MenuItem value={"INACTIVE"}>Inactive</MenuItem>
        </ReactHookFormSelect>
      </Grid>
    </Grid>
  );
};

export default TenantDetail;
